var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isTvGuidePage, getOwnTvGuideData } from "pages/tvguide";
import { prepProvider } from "pages/tvguide/Provider";
export var prepTvGuideRoute = function (headController) { return ({
    kind: "ManualRoute",
    matchOnSlug: function (slug) { return isTvGuidePage(slug); },
    navConfig: { isShown: true, hideFooter: false },
    Provider: prepProvider(headController),
    getPageCache: function (origin, slug, pageCache) {
        return getOwnTvGuideData(origin, slug).then(function (data) { return (__assign(__assign({}, pageCache), { epgCache: { slug: slug, data: data } })); });
    },
}); };
